[
  {
    "id": "SWW-B6P-L102-001",
    "module": "SpellingWW",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "question": "Hij ... morgen naar oma. (gaan)",
    "options": ["gaat", "ga", "ging", "gegaan"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_hij_zij_het_onregelmatig",
    "familyId": "SWW-TT-ONREGELMATIG-GAAN",
    "conceptId": "present_tense_irregular_gaan",
    "variantIndex": 1,
    "explanation": "Het gaat over morgen (dus niet gisteren), en het onderwerp is 'hij'.\nDe tegenwoordige tijd van 'gaan' bij hij is: gaat.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik ga. Bij hij/zij/het wordt het: gaat.",
      "2": "Dit is verleden tijd. Morgen betekent dat het niet over het verleden gaat.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'is/heeft': hij is gegaan."
    }
  },
  {
    "id": "SWW-B6P-L102-002",
    "module": "SpellingWW",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "question": "Gisteren ... hij heel hard. (rennen)",
    "options": ["rende", "rent", "renden", "gerend"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_enkelvoud_context",
    "familyId": "SWW-VT-ZWAK-ENKELVOUD",
    "conceptId": "past_tense_singular_context",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' weet je dat het verleden tijd is.\nOnderwerp is 'hij', dus enkelvoud.\nDe verleden tijd van 'rennen' is: rende.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt om verleden tijd.",
      "2": "Dit is verleden tijd meervoud (zij renden). Maar het onderwerp is enkelvoud: hij rende.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft gerend."
    }
  },
  {
    "id": "SWW-B6P-L102-003",
    "module": "SpellingWW",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "question": "De hond heeft ... (blaffen).",
    "options": ["geblaft", "geblafd", "blafte", "blaft"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_na_heeft",
    "familyId": "SWW-VD-ZWAK-TKOF-KEUZE",
    "conceptId": "past_participle_weak_t_rule",
    "variantIndex": 1,
    "explanation": "Na 'heeft' gebruik je een voltooid deelwoord.\nHele werkwoord: blaffen. Stam: blaf.\nDe f zit in 't kofschip, dus het voltooid deelwoord eindigt op t: geblaft.",
    "distractorExplanations": {
      "1": "Je kiest d, maar f zit in 't kofschip. Daarom wordt het t: geblaft.",
      "2": "Dit is verleden tijd. Na 'heeft' gebruik je het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'heeft' hoort geen tegenwoordige tijd maar een voltooid deelwoord."
    }
  },
  {
    "id": "SWW-B6P-L102-004",
    "module": "SpellingWW",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "question": "Wij ... straks naar de gymzaal. (lopen)",
    "options": ["lopen", "loopt", "liepen", "gelopen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_wij_jullie_zij",
    "familyId": "SWW-TT-MEERVOUD",
    "conceptId": "present_tense_plural_basic",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'wij', dus meervoud.\nBij meervoud is de persoonsvorm hetzelfde als het hele werkwoord: lopen.",
    "distractorExplanations": {
      "1": "Dit is enkelvoud bij hij/zij/het. Bij wij hoort: lopen.",
      "2": "Dit is verleden tijd. 'Straks' betekent dat het niet in het verleden is.",
      "3": "Dit is het voltooid deelwoord en hoort met 'hebben': wij hebben gelopen."
    }
  },
  {
    "id": "SWW-B6P-L102-005",
    "module": "SpellingWW",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "question": "De ramen zijn ... (wassen).",
    "options": ["gewassen", "gewast", "wasten", "wast"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_na_zijn",
    "familyId": "SWW-VD-STERK-BASIS",
    "conceptId": "past_participle_strong_basic",
    "variantIndex": 1,
    "explanation": "Na 'zijn' gebruik je een voltooid deelwoord.\n'Wassen' is een sterk werkwoord.\nHet voltooid deelwoord is: gewassen.",
    "distractorExplanations": {
      "1": "Dit lijkt alsof je 't kofschip gebruikt, maar 'wassen' is sterk. De juiste vorm is gewassen.",
      "2": "Dit is verleden tijd meervoud. Na 'zijn' hoort een voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd enkelvoud. Na 'zijn' hoort een voltooid deelwoord."
    }
  }
]
